<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button
          id="create-new-btn"
          variant="primary"
          class="create-new-btn"
          @click="createWarehouse"
        >
          <feather-icon icon="PlusIcon" size="15" />
          {{ $t('Create Address Book') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';

export default {
  name: 'AddressBookFilter',

  components: {
    AppFilter,
    BButton
  },

  mixins: [helper],

  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      packageStatus: [],
      addressType: []
    };
  },

  computed: {
    filterConfig() {
      return [
        {
          id: 'name',
          label: 'Address Book Name',
          type: 'text',
          placeholder: 'Address Book Name'
        },
        {
          id: 'attentionName',
          label: 'Attention Name',
          type: 'text',
          placeholder: 'Attention Name'
        },
        {
          id: 'postalCode',
          label: 'Postal Code',
          type: 'text',
          placeholder: 'Postal Code'
        },
        {
          id: 'type',
          label: 'Address Type',
          type: 'select',
          options: this.addressTypeOptions,
          placeholder: 'Make a Choice'
        },
        {
          id: 'status',
          label: 'Status',
          type: 'select',
          options: this.packageStatusTypeOptions,
          placeholder: 'Make a Choice'
        },
        {
          id: 'phoneNumber',
          label: 'Phone Number',
          type: 'text',
          inputType: 'number',
          placeholder: 'Phone Number'
        },
        {
          id: 'email',
          label: 'Email',
          type: 'text',
          placeholder: 'Email'
        },
        {
          id: 'address',
          label: 'Address',
          type: 'text',
          placeholder: 'Address'
        }
      ];
    },

    packageStatusTypeOptions() {
      return (this.packageStatus || []).map(item => ({
        value: item.value,
        label: item.info
      }));
    },

    addressTypeOptions() {
      return (this.addressType || []).map(item => ({
        value: item.value,
        label: item.info
      }));
    }
  },

  async created() {
    this.packageStatus = await this.getPackageStatus();
    this.addressType = await this.getAddressType();
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', this.getFilteredObject(filters));
    },

    createWarehouse() {
      this.$router.push('/address_book/create');
    }
  },

  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>
